/**
 * PANEL_DETAIL_DEFAULTS - Pano detay cizimi varsayilan ayarlari
 */
export const PANEL_DETAIL_DEFAULTS = {
  // --- Sayac Boyutlari ---
  meter: {
    phase3: {
      width: 22.5,          // cm
      height: 50,           // cm
      maxRows: 3,
    },
    phase1: {
      width: 15,            // cm
      height: 35,           // cm
      maxRows: 4,
    }
  },

  // --- Cerceve ---
  frame: {
    thickness: 5,           // cm - tum bolmelerde gecerli
  },

  // --- Sayac Bolmesi ---
  meterCompartment: {
    maxHeight: 150,                // cm - sayac bolmesi max yukseklik
    maxDoorWidth: 60,              // cm - tek kapak max genislik, asarsa otomatik bolunur
    placementMode: 'row',           // 'row' (Satir) | 'column' (Sutun)
    shiftSinglePhase: false,         // true ise 1F sayaclar 3F artan alanlara kaydirilir
  },

  // --- Bara Bolmesi ---
  busbarCompartment: {
    height: 50,                    // cm
    widthMode: 'BOTH',            // 'METER_ONLY' | 'DIST_ONLY' | 'BOTH'
  },

  // --- Dagitim Bolmesi ---
  distributionCompartment: {
    width: 45,                     // cm
    heightMode: 'METER_ONLY',     // 'METER_ONLY' | 'METER_PLUS_BUSBAR' (bara genisligine bagli otomatik)
    mainBreaker: {
      current: 100,                // Amperaj (A)
      poles: 4,                    // Kutup sayisi (3 veya 4)
    },
    aos: {
      breakers: [],                // [{ phase: 3, count: 5 }, { phase: 1, count: 3 }]
    },
  },

  // --- Olculendirme ---
  dimensions: {
    gap: 8,             // cm - pano kenari ile olcu cizgisi baslangici arasindaki bosluk
    offset: 5,          // cm - olcu cizgileri arasi mesafe
    lineLength: 10,     // cm - toplam olcu cizgisi ile bolme olcusu arasi
    textSize: 11,       // px - olcu yazi boyutu
    arrowSize: 3,       // cm - ok ucu boyutu
    precision: 1,       // ondalik basamak
    positions: {
      top: true,
      bottom: false,
      left: true,
      right: false,
    },
    doorPositions: {
      top: true,
      bottom: false,
      left: false,
      right: true,
    }
  },

  // --- Gorunum Modlari ---
  views: {
    withDoors: true,
    withoutDoors: true,
    viewGap: 40,        // cm - ic gorunus ile kapakli gorunus arasi mesafe
    frameMargin: 15,    // cm - cerceve ile cizim arasi mesafe
  }
};
